import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

import cable from '../cable';
import Avatar from './Avatar';

export default class MessagesConnectionItem extends Component {
  static propTypes = {
    connection: PropTypes.any.isRequired,
    currentUser: PropTypes.object.isRequired,
    selected: PropTypes.bool.isRequired,
    unread: PropTypes.bool.isRequired,
    onClick: PropTypes.func.isRequired,
    onNewMessage: PropTypes.func.isRequired,
  };

  subscribe() {
    const { connection } = this.props;
    if (!connection.id) return;

    Union.log('Item is subscribing to connection', connection.id);

    this.subscription = cable.subscriptions.create(
      {
        channel: 'MessagesChannel',
        connection_id: connection.id,
      },
      {
        received: data => {
          Union.log('Item received data for connection', data);
          this.props.onNewMessage();
        },
      }
    );
  }

  unsubscribe() {
    if (this.subscription) {
      Union.log('Item is unsubscribing from connection', this.props.connection.id);
      this.subscription.unsubscribe();
    }
  }

  componentDidMount() {
    this.subscribe();
    if (this.props.selected) {
      this.props.onClick(this.props.connection.id);
    }
  }

  componentWillUnmount() {
    this.unsubscribe();
  }

  render() {
    const { currentUser, connection, selected, onClick, unread } = this.props;
    const user =
      connection.recipient.id === currentUser.id ? connection.author : connection.recipient;
    let lastMessage = connection.last_message;

    if (!lastMessage) {
      lastMessage = {
        body: <span className="u-text-grey-dark">New connection</span>,
      };
    } else {
      lastMessage.body = lastMessage.body_plain.substring(0, 70);
    }

    return (
      <div
        className={`u-flex u-border-b u-border-grey-lighter u-p-4 u-cursor-pointer u-overflow-hidden messages-connection-item u-justify-between ${
          selected ? 'messages-connection-item--active' : ''
        }`}
        key={connection.id}
        onClick={() => onClick(connection.id)}>
        <div className="u-flex">
          <Avatar
            src={user.avatar_url}
            className="u-w-12 u-h-12 u-flex-none"
            type="user"
            name={user.full_name}
          />

          <div className="u-ml-3 u-block">
            <strong className="u-block u-mb-1 u-leading-none u-flex u-items-center">
              <span className="u-inline-block u-mr-1">{user.full_name}</span>
            </strong>

            <div
              className="u-text-grey-darker u-text-xs u-mb-1 u-overflow-hidden"
              style={{
                display: '-webkit-box',
                WebkitLineClamp: 3,
                WebkitBoxOrient: 'vertical',
              }}>
              {connection.last_message &&
              connection.last_message.sender_id === currentUser.id &&
              'You: '}
              {lastMessage.body}
            </div>

            <em className="u-block u-text-grey u-not-italic u-text-xs">
              {lastMessage.created_at &&
              moment(lastMessage.created_at).calendar(null, { sameElse: 'MMMM D, h:mm A' })}
            </em>
          </div>
        </div>
        <div className="u-flex u-items-center">
          {unread && <span className="u-inline-block u-rounded-full u-bg-blue u-w-3 u-h-3" />}
        </div>
      </div>
    );
  }
}
